<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <div class="notification-area">
      <feather-icon
        icon="BellIcon"
        class="cursor-pointer"
        :badge="notifications.length"
        badgecolor="warning"
      />
    </div>
    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ notifications.length }} New</h3>
        <p class="opacity-75">App Notifications</p>
      </div>
      <VuePerfectScrollbar
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="(notification, index) in notifications"
            :key="index"
            class="notification-item px-4 py-3 border-b border-solid d-theme-border-grey-light cursor-pointer hover:bg-gray-200"
            @click="viewNotification(notification)"
          >
            <div class="flex justify-between">
              <div>
                <p class="text-success font-semibold">
                  {{ notification.title }}
                </p>
                <p class="text-success font-semibold">
                  {{ notification.name }}
                </p>
                <p class="text-success font-semibold">
                  {{ notification.phone }}
                </p>
                <p class="text-sm text-gray-500">
                  {{ elapsedTime(notification.time) }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </VuePerfectScrollbar>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import socket from "@/http/socket";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      agentId: null,
      notifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  methods: {
    handleCustomerDetails(data) {
      const notification = {
        title: `Account No :${data.accountNo}`,
        name: `Name :${data.firstname}`,
        phone: `Phone Number :${data.mobileNo}`,
        time: new Date(),
        userId: data.id,
      };
      this.notifications.unshift(notification);
      sessionStorage.setItem(
        "ngb:notifications",
        JSON.stringify(this.notifications)
      );
      window.addEventListener("beforeunload", () => {
        sessionStorage.removeItem("ngb:notifications");
      });
      this.$vs.notify({
        title: `Incoming Call :${data.firstname}`,
        color: "success",
        timer: 30000,
        click: () => {
          this.viewNotification(notification);
        },
      });
    },
    viewNotification(notification) {
      // Navigate to the customer's detail page
      this.$router.push(`/customers/view_customer/${notification.userId}`);
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;
      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);
      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);
      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);
      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);
      var years = timeDiff;
      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " sec ago" : "just now");
      }
      return "Just Now";
    },
    randomDate({ hr, min, sec }) {
      let date = new Date();
      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);
      return date;
    },
  },
  mounted() {
    const user = JSON.parse(sessionStorage.getItem("ngb:user") || "{}");
    this.agentId = user.userId || 1;
    socket.emit("registerAgent", this.agentId);
    socket.on("customerDetails", this.handleCustomerDetails);
  },
  beforeDestroy() {
    socket.off("customerDetails", this.handleCustomerDetails);
  },
};
</script>
<style lang="scss" scoped>
.notification-area {
  background: rgba(104, 94, 204, 0.15);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  .feather-icon {
    vertical-align: middle;
    margin-top: 8px;
  }
}
</style>
